"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyV1LiveWorkoutsGet = void 0;
exports.v1LiveWorkoutsGetSetMock = v1LiveWorkoutsGetSetMock;
exports.v1LiveWorkoutsGet = v1LiveWorkoutsGet;
exports.useQueryV1LiveWorkoutsGet = useQueryV1LiveWorkoutsGet;
exports.useInfiniteQueryV1LiveWorkoutsGet = useInfiniteQueryV1LiveWorkoutsGet;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function v1LiveWorkoutsGetSetMock(mock) {
    setMock = mock;
}
async function v1LiveWorkoutsGet(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/wolf-dashboard-service/v1/live-workouts`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    queryParams.softwareNumber = params.softwareNumber;
    queryParams.page = params.page;
    queryParams.pageSize = params.pageSize;
    if ((client.statusChecksEnabled || params.forceStatusCheck) && (await (0, is_down_1.wolfDashboardServiceIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'GET', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyV1LiveWorkoutsGet = 'wolf-dashboard-service:v1LiveWorkoutsGet:get';
function useQueryV1LiveWorkoutsGet(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyV1LiveWorkoutsGet, requestParams];
    return reactQuery.useQuery(key, queryFn, queryOptions);
}
function useInfiniteQueryV1LiveWorkoutsGet(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyV1LiveWorkoutsGet, requestParams];
    return reactQuery.useInfiniteQuery(key, queryFn, queryOptions);
}
function queryFn({ queryKey, pageParam }) {
    const [, params] = queryKey;
    const promise = v1LiveWorkoutsGet(pageParam ? Object.assign(Object.assign({}, params), pageParam) : params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=v1-live-workouts-get.js.map